/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FroalaImageResponse } from '../models/froala-image-response';
import { imageUpload } from '../fn/froala/image-upload';
import { ImageUpload$Params } from '../fn/froala/image-upload';

@Injectable({ providedIn: 'root' })
export class FroalaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `imageUpload()` */
  static readonly ImageUploadPath = '/rest/froala/image-upload/{entityFieldName}/{entityId}';

  /**
   * Upload image (from froala editor) to permanent storage. Currently images are uploaded to AWS S3.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imageUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  imageUpload$Response(params: ImageUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<FroalaImageResponse>> {
    return imageUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload image (from froala editor) to permanent storage. Currently images are uploaded to AWS S3.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imageUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  imageUpload(params: ImageUpload$Params, context?: HttpContext): Observable<FroalaImageResponse> {
    return this.imageUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<FroalaImageResponse>): FroalaImageResponse => r.body)
    );
  }

}
